(function() {
  var settings = {
    enabled: false,
    excludeTag: "no-discount",
    nativeCompareMode: "override",
    global: {
      discount: 5,
      message: "Save big during our birthday sale",
      appliesOnetime: true,
      appliesSubscription: false
    },
    slots: [
      {
        tag: "",
        discount: 0,
        message: "",
        appliesOnetime: true,
        appliesSubscription: false
      },
      {
        tag: "",
        discount: 0,
        message: "",
        appliesOnetime: true,
        appliesSubscription: false
      },
      {
        tag: "",
        discount: 0,
        message: "",
        appliesOnetime: true,
        appliesSubscription: false
      }
    ]
  };

  window.promoDisplaySettings = settings;

  function parseProductTags(tagString) {
    if (!tagString) {
      return [];
    }
    return tagString.split('|').map(function(t) { return t.trim(); }).filter(Boolean);
  }

  function resolveRule(tags) {
    if (!settings.enabled) {
      return null;
    }
    if (settings.excludeTag && tags.indexOf(settings.excludeTag) > -1) {
      return null;
    }
    var i;
    for (i = 0; i < settings.slots.length; i++) {
      var slot = settings.slots[i];
      if (slot.tag && tags.indexOf(slot.tag) > -1 && slot.discount > 0) {
        return slot;
      }
    }
    if (settings.global.discount > 0) {
      return settings.global;
    }
    return null;
  }

  $s.resolvePromoDisplay = function(options) {
    var tags = options.tags || [];
    var variant = options.variant;
    var rule = resolveRule(tags);
    if (!rule || !variant) {
      return { active: false };
    }
    var active = true;
    if (settings.nativeCompareMode === 'skip') {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        active = false;
      }
    }
    if (!active) {
      return { active: false };
    }
    return {
      active: true,
      percent: rule.discount,
      message: rule.message || '',
      appliesOnetime: !!rule.appliesOnetime,
      appliesSubscription: !!rule.appliesSubscription
    };
  };

  function nativeSubscriptionPricePair(variant, planPrice, planCompareAtPrice) {
    var finalCents = planPrice != null ? planPrice : variant.price;
    var compareCents = null;
    if (planCompareAtPrice && planCompareAtPrice > finalCents) {
      compareCents = planCompareAtPrice;
    } else if (planPrice != null && variant.compare_at_price && variant.compare_at_price > planPrice) {
      compareCents = variant.compare_at_price;
    }
    return { compareCents: compareCents, finalCents: finalCents, promo: false };
  }

  function nativeOnetimePricePair(variant) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      return { compareCents: variant.compare_at_price, finalCents: variant.price, promo: false };
    }
    return { compareCents: null, finalCents: variant.price, promo: false };
  }

  $s.getPromoDisplayPricePair = function(options) {
    var tags = options.tags || [];
    var variant = options.variant;
    var planPrice = options.planPrice;
    var planCompareAtPrice = options.planCompareAtPrice;
    var isSubscription = !!options.isSubscription;
    var promo = $s.resolvePromoDisplay({ tags: tags, variant: variant });

    if (!promo.active) {
      if (isSubscription) {
        return nativeSubscriptionPricePair(variant, planPrice, planCompareAtPrice);
      }
      return nativeOnetimePricePair(variant);
    }

    if (isSubscription) {
      if (!promo.appliesSubscription || planPrice == null) {
        return nativeSubscriptionPricePair(variant, planPrice, planCompareAtPrice);
      }
      var subMultiplier = (100 - promo.percent) / 100;
      return {
        compareCents: variant.price,
        finalCents: Math.round(planPrice * subMultiplier),
        promo: true
      };
    }

    if (!promo.appliesOnetime) {
      return nativeOnetimePricePair(variant);
    }

    var multiplier = (100 - promo.percent) / 100;
    return {
      compareCents: variant.price,
      finalCents: Math.round(variant.price * multiplier),
      promo: true
    };
  };

  $s.getProductTagsFromElement = function(element) {
    var main = element.closest('.product-main-element') || element;
    return parseProductTags(main.getAttribute('data-product-tags') || '');
  };
})();
